import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import strings from "translate/language";
import {
  isEmpty,
  seo,
  ValidateExtensionImge,
  ValidateExtensionVideo,
} from "utils/utils";
import { addSupportForum } from "reduxStore/action/supportForumAction";
import { AutocompletePlace } from "component/common/PlacesAutocomplete";
import Breadcrumb from "component/common/breadcrumb";

const AddNewSupportForum = () => {
  const navigate = useNavigate();
  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState(null);
  const [form, setForm] = useState({});
  const addSupportForumSelector =
    useSelector((state) => state.supportForum) || [];

  const [uploadFields, setUploadFields] = useState([{ uploadFile: "" }]);
  const [videoFileds, setVideoFileds] = useState([{ uploadFile: "" }]);
  const handleChange = (index, event) => {
    let data = [...uploadFields];
    data[index]["uploadFile"] = event.target.files;
    setUploadFields(data);
  };
  const addUploadFields = () => {
    let newUploadField = { uploadFile: "" };
    setUploadFields([...uploadFields, newUploadField]);
  };
  const removeFields = (index) => {
    let data = [...uploadFields];
    data.splice(index, 1);
    setUploadFields(data);
  };
  const supportForumhandleChange = (index, event) => {
    let data = [...videoFileds];
    data[index]["uploadFile"] = event.target.files;
    setVideoFileds(data);
  };
  const addSupportForumFields = () => {
    let newPropertyField = { uploadFile: "" };
    setVideoFileds([...videoFileds, newPropertyField]);
  };
  const removeSupportForumFields = (index) => {
    let data = [...videoFileds];
    data.splice(index, 1);
    setVideoFileds(data);
  };

  useEffect(() => {
    if (addSupportForumSelector.create === true) {
      if (addSupportForumSelector?.response?.status === 200) {
        setForm({});
        navigatpage("/supportForum");
      }
    }
  }, [addSupportForumSelector]);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };
  const handleInputArea = (e) => {
    const nextFormState = {
      ...form,
      location: e,
      latitude: "",
      longitude: "",
    };
    setForm(nextFormState);
  };
  const onSelect = (latLng, location) => {
    const nextFormState = {
      ...form,
      location: location,
      latitude: latLng.lat,
      longitude: latLng.lng,
    };
    setForm(nextFormState);
  };

  const handleSubmit = () => {
    if (!handleValid()) {
      const formData = new FormData();
      formData.append("title", form.title);
      formData.append("description", form.description);
      formData.append("location", form.location);
      formData.append("longitude", form.longitude);
      formData.append("latitude", form.latitude);
      form.images = uploadFields.map((i) => i.uploadFile);
      form.videos = videoFileds.map((i) => i.uploadFile);
      [...form.images].forEach((file) => {
        formData.append("images", file[0]);
      });
      [...form.videos].forEach((file) => {
        formData.append("videos", file[0]);
      });

      dispatch(addSupportForum(formData));
    }
  };

  const handleValid = () => {
    let err = {};
    let formError = false;
    if (!form.title) {
      formError = true;
      err["title"] = strings.titleErr;
    }
    if (!form.location) {
      formError = true;
      err["location"] = strings.locationerr;
    } else if (!form.longitude) {
      formError = true;
      err["location"] = strings.validLctionErr;
    } else if (form.longitude === "undefined") {
      formError = true;
      err["location"] = strings.validLctionErr;
    }
    if (!form.description) {
      formError = true;
      err["description"] = strings.descErr;
    }
    if (uploadFields.length === 1 && !uploadFields[0].uploadFile) {
      formError = true;
      err["images"] = strings.propertyImgErr;
    }

    if (videoFileds.length === 1 && !videoFileds[0].uploadFile) {
      formError = true;
      err["videos"] = strings.videoErr;
    }

    setFormVaild(err);
    return formError;
  };
  useEffect(() => {
    seo({
      title: "Add New Support Forum",
      metaDescription: "Add new support forum",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.addnewsupportforum}
        url={"/supportforum"}
        parentListing={strings.supportForumList}
        titleactive={strings.addnewsupportforum}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header pb-0">
                <h5>{strings.addNewsupportforum}</h5>
              </div>
              <form className="form theme-form">
                <div className="card-body">
                  <div className="row ">
                    <div className="col-md-8 ">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlFirstName">
                          {strings.title}
                          <span className="required-field"></span>
                        </label>
                        <input
                          className="form-control"
                          id="exampleFormControlFirstName"
                          type="text"
                          placeholder={strings.title}
                          name="title"
                          value={form.title}
                          onChange={handleInputField}
                          autoComplete="off"
                        />
                        {formVaild?.title && (
                          <span style={{ color: "red" }}>
                            {formVaild?.title}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlSelect9">
                          {strings.location}
                          <span className="required-field"></span>
                        </label>
                        <AutocompletePlace
                          placeholder={strings.location}
                          name="location"
                          value={form.location}
                          onChange={handleInputArea}
                          onSelect={onSelect}
                        />
                        {formVaild?.location && (
                          <span style={{ color: "red" }}>
                            {formVaild?.location}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8">
                      <div className="mb-3">
                        <label htmlFor="exampleFormControlLastName">
                          {strings.description}
                          <span className="required-field"></span>
                        </label>
                        <textarea
                          name="description"
                          placeholder={strings.description}
                          value={form.description}
                          onChange={handleInputField}
                          autoComplete="off"
                          className="form-control"
                          id=""
                          cols="74"
                          rows="5"
                        ></textarea>
                        {formVaild?.description && (
                          <span style={{ color: "red" }}>
                            {formVaild?.description}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row align-items-center">
                    <div className="col">
                      <label htmlFor="exampleFormControlSelect9">
                        {strings.images}
                        <span className="required-field"></span>
                      </label>
                      <div className="row mb-3">
                        {uploadFields &&
                          uploadFields.map((form, index) => {
                            return (
                              <div className="row col-md-11" key={index}>
                                <div className="col-md-9 mt-1">
                                  <input
                                    className="form-control"
                                    type="file"
                                    name="file"
                                    accept="image/*"
                                    onChange={(event) => {
                                      const validFile = ValidateExtensionImge(
                                        event.target
                                      );
                                      let data = [...uploadFields];
                                      if (validFile === true) {
                                        data[index]["uploadFile"] =
                                          event.target.files;
                                        data[index]["validMedia"] = null;

                                        setUploadFields(data);
                                        setFormVaild({
                                          ...formVaild,
                                          images: null,
                                        });
                                      } else {
                                        data[index]["uploadFile"] = "";
                                        data[index]["validMedia"] = validFile;
                                        setUploadFields(data);
                                      }
                                    }}
                                  />
                                  {formVaild?.images && index === 0 && (
                                    <span style={{ color: "red" }}>
                                      {formVaild?.images}
                                    </span>
                                  )}
                                  {form.validMedia &&
                                    String(form.uploadFile) === "" && (
                                      <span style={{ color: "red" }}>
                                        {form.validMedia}
                                      </span>
                                    )}
                                </div>
                                {index != 0 && (
                                  <div className="col-md-1 mt-1">
                                    <button
                                      style={{ marginTop: "2px" }}
                                      className="btn btn-danger"
                                      type="button"
                                      onClick={() => removeFields(index)}
                                    >
                                      -
                                    </button>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        <div className="col-md-1">
                          <button
                            style={{ marginTop: "9px" }}
                            className="btn btn-success"
                            type="button"
                            onClick={addUploadFields}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row align-items-center">
                    <div className="col">
                      <label htmlFor="exampleFormControlSelect9">
                        {strings.video}
                        <span className="required-field"></span>
                      </label>
                      <div className="row mb-3">
                        {videoFileds &&
                          videoFileds.map((form, index) => {
                            return (
                              <div className="col-sm-11 row" key={index}>
                                <div className="col-sm-9 mt-1">
                                  <input
                                    className="form-control"
                                    id="exampleFormControlFirstName"
                                    type="file"
                                    accept="video/*"
                                    name="file"
                                    onChange={(event) => {
                                      const validFile = ValidateExtensionVideo(
                                        event.target
                                      );
                                      let data = [...videoFileds];
                                      if (validFile === true) {
                                        data[index]["uploadFile"] =
                                          event.target.files;
                                        data[index]["validMedia"] = null;

                                        setVideoFileds(data);
                                        setFormVaild({
                                          ...formVaild,
                                          videos: null,
                                        });
                                      } else {
                                        data[index]["uploadFile"] = "";
                                        data[index]["validMedia"] = validFile;
                                        setVideoFileds(data);
                                      }
                                    }}
                                  />
                                  {formVaild?.videos && index === 0 && (
                                    <span style={{ color: "red" }}>
                                      {formVaild?.videos}
                                    </span>
                                  )}
                                  {form.validMedia &&
                                    String(form.uploadFile) === "" && (
                                      <span style={{ color: "red" }}>
                                        {form.validMedia}
                                      </span>
                                    )}
                                </div>
                                {index != 0 && (
                                  <div className="col-sm-1 mt-1">
                                    <button
                                      style={{ marginTop: "2px" }}
                                      className="btn btn-danger"
                                      type="button"
                                      onClick={() =>
                                        removeSupportForumFields(index)
                                      }
                                    >
                                      -
                                    </button>
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        <div className="col-sm-1">
                          <button
                            style={{ marginTop: "8px" }}
                            className="btn btn-success"
                            type="button"
                            onClick={addSupportForumFields}
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12 d-flex justify-content-end">
                    <div className="card-footer">
                      <button
                        className="btn btn-color"
                        type="button"
                        onClick={() => handleSubmit()}
                      >
                        {strings.submit}
                      </button>
                    </div>
                  </div>
                  {!isEmpty(formVaild) && (
                    <div className="col-md-12 float-right">
                      <span
                        style={{
                          color: "red",
                          float: "right",
                          // padding: "5px 15px 25px 5px",
                        }}
                      >
                        {strings.fieldRequired}
                      </span>
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AddNewSupportForum;
